class ArticleVideo extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    window.addEventListener('DOMContentLoaded', () => {
      this.playButton = this.querySelector('[data-article-video-play-button]');
      this.posterWrapper = this.querySelector('[data-article-video-poster-wrapper]');
      this.player = this.querySelector('[data-article-video-player]');
      this.html5Video = this.querySelector('[data-article-video-html5]');

      if (this.playButton) {
        this.playButton.addEventListener('click', () => this.playVideo());
      }
    });
  }

  playVideo() {
    if (!this.html5Video) {
      return;
    }

    try {
      this.html5Video.load();
      
      if (this.posterWrapper) {
        this.posterWrapper.style.display = 'none';
      }
      if (this.player) {
        this.player.style.display = 'block';
      }

      const playPromise = this.html5Video.play();

      if (playPromise !== undefined) {
        playPromise
          .then(() => {
          })
          .catch(error => {
            if (this.posterWrapper) {
              this.posterWrapper.style.display = 'block';
            }
            if (this.player) {
              this.player.style.display = 'none';
            }
          });
      }
    } catch (error) {
      if (this.posterWrapper) {
        this.posterWrapper.style.display = 'block';
      }
      if (this.player) {
        this.player.style.display = 'none';
      }
    }
  }
}

if (!customElements.get('article-video')) {
  customElements.define('article-video', ArticleVideo);
}